// client/src/components/agent/actions/CreateOrderView.jsx
import { useState, useEffect } from 'react';
import theme from '../../../theme';

export default function CreateOrderView({ token, conv, onBack }) {
  const [products, setProducts] = useState([]);
  const [lines, setLines] = useState([]); // {product_id, name, price, quantity, custom}
  const [form, setForm] = useState({ phone: '', customer_name: '', customer_email: '', department: '', city: '', address: '' });
  const [withDom, setWithDom] = useState(false);
  const [dom, setDom] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const c = theme.colors;
  const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
  const inputStyle = { width: '100%', padding: '6px 8px', background: c.background, color: c.text, border: `1px solid ${c.border}`, borderRadius: 6, marginBottom: 6, boxSizing: 'border-box', fontSize: 13 };

  useEffect(() => {
    fetch('/api/agent/products', { headers }).then((r) => r.json()).then(setProducts).catch(() => {});
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  // Prellenar teléfono con el de la conversación; reiniciar al cambiar de conversación.
  useEffect(() => {
    setForm({ phone: conv?.owner || '', customer_name: '', customer_email: '', department: '', city: '', address: '' });
    setLines([]); setWithDom(false); setDom(''); setMsg('');
  }, [conv?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const subtotal = lines.reduce((s, l) => s + Number(l.price || 0) * Number(l.quantity || 0), 0);
  const total = subtotal + (withDom ? Number(dom || 0) : 0);

  const addExisting = () => setLines((p) => [...p, { product_id: '', name: '', price: 0, quantity: 1, custom: false }]);
  const addCustom = () => setLines((p) => [...p, { product_id: '', name: '', price: 0, quantity: 1, custom: true }]);

  const setLine = (i, patch) => setLines((p) => p.map((l, j) => j === i ? { ...l, ...patch } : l));

  const pickProduct = (i, id) => {
    const prod = products.find((x) => String(x.id) === String(id));
    setLine(i, { product_id: id, name: prod?.title || '', price: Number(prod?.price || 0) });
  };

  const create = async () => {
    if (!lines.length) { setMsg('Agrega al menos un producto'); return; }
    setSaving(true); setMsg('');
    try {
      const r = await fetch('/api/agent/orders', {
        method: 'POST', headers,
        body: JSON.stringify({ ...form, items: lines, domicile_value: withDom ? Number(dom || 0) : 0 }),
      });
      if (r.ok) { setMsg('Pedido creado ✓'); setLines([]); }
      else setMsg('Error al crear');
    } catch { setMsg('Error de red'); }
    setSaving(false);
  };

  return (
    <div style={{ padding: 12, color: c.text, overflowY: 'auto' }}>
      <button onClick={onBack} style={{ background: 'none', border: 'none', color: c.primary, cursor: 'pointer', marginBottom: 8 }}>{'← Atrás'}</button>
      <h4 style={{ margin: '4px 0 10px' }}>Crear pedido</h4>

      <input style={inputStyle} placeholder="Teléfono" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
      <input style={inputStyle} placeholder="Nombre del cliente" value={form.customer_name} onChange={(e) => setForm({ ...form, customer_name: e.target.value })} />
      <input style={inputStyle} placeholder="Email" value={form.customer_email} onChange={(e) => setForm({ ...form, customer_email: e.target.value })} />
      <input style={inputStyle} placeholder="Departamento" value={form.department} onChange={(e) => setForm({ ...form, department: e.target.value })} />
      <input style={inputStyle} placeholder="Ciudad" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
      <input style={inputStyle} placeholder="Dirección" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />

      {lines.map((l, i) => (
        <div key={i} style={{ border: `1px solid ${c.border}`, borderRadius: 6, padding: 6, marginBottom: 6 }}>
          {l.custom ? (
            <input style={inputStyle} placeholder="Nombre producto" value={l.name} onChange={(e) => setLine(i, { name: e.target.value })} />
          ) : (
            <select style={inputStyle} value={l.product_id} onChange={(e) => pickProduct(i, e.target.value)}>
              <option value="">{'— Producto —'}</option>
              {products.map((p) => <option key={p.id} value={p.id}>{p.title}</option>)}
            </select>
          )}
          <div style={{ display: 'flex', gap: 6 }}>
            <input style={{ ...inputStyle, flex: 1 }} type="number" onWheel={(e) => e.currentTarget.blur()} placeholder="Precio" value={l.price} onChange={(e) => setLine(i, { price: e.target.value })} />
            <input style={{ ...inputStyle, width: 70 }} type="number" onWheel={(e) => e.currentTarget.blur()} placeholder="Cant." value={l.quantity} onChange={(e) => setLine(i, { quantity: e.target.value })} />
          </div>
        </div>
      ))}

      <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
        <button onClick={addExisting} style={{ flex: 1, background: 'none', border: `1px dashed ${c.border}`, color: c.primary, borderRadius: 6, padding: '6px', cursor: 'pointer' }}>{'+ Producto'}</button>
        <button onClick={addCustom} style={{ flex: 1, background: 'none', border: `1px dashed ${c.border}`, color: c.primary, borderRadius: 6, padding: '6px', cursor: 'pointer' }}>{'+ No existente'}</button>
      </div>

      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, marginBottom: 6 }}>
        <input type="checkbox" checked={withDom} onChange={(e) => setWithDom(e.target.checked)} /> Agregar domicilio
      </label>
      {withDom && <input style={inputStyle} type="number" onWheel={(e) => e.currentTarget.blur()} placeholder="Valor domicilio" value={dom} onChange={(e) => setDom(e.target.value)} />}

      <div style={{ fontWeight: 700, margin: '8px 0' }}>Total a pagar: ${total.toLocaleString('es-CO')}</div>

      <button onClick={create} disabled={saving} style={{ width: '100%', background: c.primary, color: '#001018', border: 'none', borderRadius: 6, padding: '8px', cursor: 'pointer', opacity: saving ? 0.6 : 1 }}>
        {saving ? 'Creando…' : 'Crear'}
      </button>
      {msg && <div style={{ marginTop: 8, fontSize: 13, color: msg.includes('✓') ? c.success : c.error }}>{msg}</div>}
    </div>
  );
}
